/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Clearschedule3Inputs */

const en_coinvestments_draftemail_clearschedule3 = /** @type {(inputs: Coinvestments_Draftemail_Clearschedule3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear schedule`)
};

/**
* | output |
* | --- |
* | "Clear schedule" |
*
* @param {Coinvestments_Draftemail_Clearschedule3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_clearschedule3 = /** @type {((inputs?: Coinvestments_Draftemail_Clearschedule3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Clearschedule3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_clearschedule3(inputs)
});
export { coinvestments_draftemail_clearschedule3 as "coInvestments_draftEmail_clearSchedule" }